export enum FootnoteEvents {
    FOOTNOTE_UPDATED = 'footnote:updated',
    FOOTNOTE_RESET = 'footnote:namespace:reset'
}
